import { FeatureFlagKey_enum } from '../../../graphql/hasura/generated';

export function validateSelectedFeatureFlags(featureFlagKeys: FeatureFlagKey_enum[]) {
  if (
    featureFlagKeys.includes(FeatureFlagKey_enum.GATEWAY_ACCESS_MANAGER) &&
    featureFlagKeys.includes(FeatureFlagKey_enum.GATEWAY_MOBILE_ENHANCER)
  ) {
    throw new Error('Gateway Access Manager and Gateway Mobile Enhancer cannot both be selected');
  }

  if (
    featureFlagKeys.includes(FeatureFlagKey_enum.GATEWAY_PIN_CODES) &&
    !featureFlagKeys.includes(FeatureFlagKey_enum.GATEWAY_ACCESS_MANAGER)
  ) {
    throw new Error('Gateway PIN Codes cannot be enabled without Gateway Access Manager');
  }

  if (
    featureFlagKeys.includes(FeatureFlagKey_enum.GATEWAY_TEMP_GUEST_PIN_CODES) &&
    !featureFlagKeys.includes(FeatureFlagKey_enum.GATEWAY_ACCESS_MANAGER)
  ) {
    throw new Error('Temporary Guest PIN Codes cannot be enabled without Gateway Access Manager');
  }

  if (
    featureFlagKeys.includes(FeatureFlagKey_enum.VENDOR_PASSCODES) &&
    !featureFlagKeys.includes(FeatureFlagKey_enum.SMART_SIGNS)
  ) {
    throw new Error('Vendor Passcodes cannot be enabled without Smart Signs');
  }

  if (
    featureFlagKeys.includes(FeatureFlagKey_enum.VIRTUAL_DIRECTORY) &&
    !featureFlagKeys.includes(FeatureFlagKey_enum.SMART_SIGNS)
  ) {
    throw new Error('Virtual Directory cannot be enabled without Smart Signs');
  }
}
